import { useTranslation } from 'react-i18next'
import type { UserStandard } from '@/shared/hooks/api/userStandards'
import { ConfirmDialog } from '@/components/confirm-dialog'

type DeleteStandardDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  standard: UserStandard | null
  isLoading?: boolean
  onConfirm: () => void
}

export function DeleteStandardDialog({
  open,
  onOpenChange,
  standard,
  isLoading,
  onConfirm,
}: DeleteStandardDialogProps) {
  const { t } = useTranslation(['standardsLibrary', 'common'])

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={onConfirm}
      title={t('standardsLibrary:deleteDialog.title')}
      desc={t('standardsLibrary:deleteDialog.description', {
        reference: standard?.reference ?? '',
      })}
      cancelBtnText={t('common:actions.cancel')}
      confirmText={t('common:actions.delete')}
      destructive
      isLoading={isLoading}
      disabled={!standard}
    />
  )
}
